import {Component} from '@angular/core';

@Component({
    selector: 'yo-processus',
    templateUrl: './processus.component.html',
    styleUrls: ['./processus.component.scss'],
    standalone: false
})
export class ProcessusComponent {
  constructor() { }
}
